import Video from '../../Inamove/Components/Video/Video'
import CinematicContainer from '../../Inamove/Containers/CinematicContainer/CinematicContainer'
import Config from '../../Inamove/Containers/Config'
import GameSceneContainer from '../../Inamove/Containers/GameSceneContainer/GameSceneContainer'
import InventoryContainer from '../../Inamove/Containers/InventoryContainer/InventoryContainer'
import LoadingContainer from '../../Inamove/Containers/LoadingContainer/LoadingContainer'

export default async function () {
    InventoryContainer.clean()
    const V1 = new Video(Config.CINEMATIC_PATH + 'V1' + Config.VIDEO_FILE_EXT)
    CinematicContainer.setVideo(V1)

    GameSceneContainer.hide()
    InventoryContainer.hide()
    LoadingContainer.hide()
    CinematicContainer.show()

    await CinematicContainer.play()
}
